import { useState } from 'react'
import { LayoutDashboard, LogOut, PlusCircle, Settings } from 'lucide-react'
import { useQuery } from '@tanstack/react-query'
import { Navigate, NavLink, Route, Routes, useLocation } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import JobCreate from './pages/JobCreate'
import JobDetail from './pages/JobDetail'
import Companies from './pages/Companies'
import SettingsPage from './pages/Settings'
import Login from './pages/Login'
import { healthApi } from './services/api'

const AUTH_KEY = 'checko-control-auth'

const navItems = [
  { to: '/', label: 'Панель', icon: LayoutDashboard, end: true },
  { to: '/jobs/new', label: 'Новый сбор', icon: PlusCircle },
  { to: '/settings', label: 'Настройки', icon: Settings },
]

export default function App() {
  const [isAuth, setIsAuth] = useState(() => localStorage.getItem(AUTH_KEY) === '1')
  const location = useLocation()
  const { data: health, isError } = useQuery({
    queryKey: ['health'],
    queryFn: healthApi.check,
    retry: 1,
    refetchInterval: 30000,
    enabled: isAuth && location.pathname !== '/login',
  })

  const login = () => { localStorage.setItem(AUTH_KEY, '1'); setIsAuth(true) }
  const logout = () => { localStorage.removeItem(AUTH_KEY); setIsAuth(false) }

  if (!isAuth) return <Login onLogin={login} />

  const isHealthy = health?.status === 'healthy'

  return (
    <div className="app-layout">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="sidebar-logo-icon">C</div>
            <div className="sidebar-logo-text">
              <h1>Checko Control</h1>
              <p>Мониторинг сбора данных</p>
            </div>
          </div>
        </div>

        <div className="sidebar-status-area">
          <div className={`sidebar-status ${isError ? 'sidebar-status--error' : !isHealthy ? 'sidebar-status--warning' : ''}`}>
            <span className="pulse-dot" />
            <span>{isError ? 'Backend недоступен' : isHealthy ? 'Система работает' : 'Подключение...'}</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `nav-link ${isActive ? 'nav-link--active' : ''}`}>
              <Icon size={18} />
              <span>{label}</span>
            </NavLink>
          ))}
          <a href="/leasing/" className="nav-link">
            <span style={{ fontSize: 18, lineHeight: 1 }}>🚛</span>
            <span>Лизинг РФ</span>
          </a>
        </nav>

        <div className="sidebar-footer">
          <button className="btn btn-ghost" style={{ width: '100%', justifyContent: 'flex-start' }} onClick={logout}>
            <LogOut size={16} />
            <span>Выйти</span>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/jobs/new" element={<JobCreate />} />
          <Route path="/jobs/:id" element={<JobDetail />} />
          <Route path="/jobs/:id/companies" element={<Companies />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}
